$(document).ready(function() {
  ;(function($) {
    $('.js-quiz-reveal-answer').on('click', function (event) {
      $(this).closest('.quiz__answer').find('.quiz__answer-text').show()
    })
  })(window.jQuery)
})
